module.exports = "./img/desktop_logo.8fcb405.png";